import { CommonModule } from '@angular/common';
import { Component, Inject, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IHearingSchedule } from '@app/dashboard/models/hearing-schedule';

@Component({
  selector: 'app-hearing-case-details',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './hearing-case-details.component.html',
  styleUrl: './hearing-case-details.component.scss'
})
export class HearingCaseDetailsComponent {

  public showLoader: WritableSignal<boolean> = signal(false);

  constructor(
    public dialogRef: MatDialogRef<HearingCaseDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IHearingSchedule
  ) {
    //console.log(data);
  }
}
